export const PHONE_PLACEHOLDER = '+36 30 123 4567';
export const PHONE_REQUIRED_MESSAGE = 'Add meg a telefonszámot.';
export const PHONE_FORMAT_MESSAGE =
  'Telefon formátum: adj meg legalább 7 számjegyet; országkód, szóköz, kötőjel és zárójel is használható.';

export function isValidFlexiblePhone(value) {
  const raw = String(value || '').trim();
  if (!raw) return false;

  if (/[^0-9+().\-\s]/.test(raw)) return false;

  const plusCount = (raw.match(/\+/g) || []).length;
  if (plusCount > 1) return false;
  if (plusCount === 1 && raw[0] !== '+') return false;

  const digitCount = raw.replace(/\D/g, '').length;
  return digitCount >= 7 && digitCount <= 15;
}
